module.exports = __webpack_public_path__ + "static/media/ting.409a9c3c.png";